import React from "react";
import useNoticeList from "./NoticeList.hook";
import Loader from "../../common/components/Loader";
import Flex from "../../common/components/Flex";
import Button from "../../common/components/Button";
import Grid from "../../common/components/Grid";
import theme from "../../../lib/theme";
import NoticeCard from "./NoticeCard";

function NoticeList() {
  const {
    refs: { fetchMoreRef },
    models: { loading, data, showNewRow },
    operations: { toggleShowNewRow },
  } = useNoticeList();

  if (loading) return <Loader />;

  return (
    <>
      <Flex justifyContent="flex-end">
        <Button text="추가하기" onClick={() => toggleShowNewRow(true)} />
      </Flex>
      <Grid
        gridTemplateColumns="repeat(4, 1fr)"
        gap={theme.spacing[12]}
        width="100%"
      >
        {showNewRow && (
          <NoticeCard notice={null} onCancel={() => toggleShowNewRow(false)} />
        )}
        {data?.map((notice) => (
          <NoticeCard notice={notice} key={notice?.id} />
        ))}
      </Grid>
    </>
  );
}

export default NoticeList;
